import type { TFunction } from "i18next";

import { getFieldKindStrategy } from "features/shared/lib/technical-config-tab/fieldKindStrategies";
import { getTableTypicalColumn } from "utils/components";

import type { LayeredConstructionCatalogTableRow, LayerRow } from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

const catalogValueClassName = "font-ds-body-regular-xs";

const getNumberCatalogCell = (t: TFunction, value: null | number | string | undefined) =>
  getFieldKindStrategy("number").formatCatalogValue(value, t);

const getStringCatalogCell = (t: TFunction, value: null | string | undefined) =>
  getFieldKindStrategy("string").formatCatalogValue(value, t);

const i18nKey = (variant: LayeredConstructionVariant, key: string) => `TechnicalData.${variant.i18nKey}.${key}`;

export const getTypePoolTableHeaders = (t: TFunction, variant: LayeredConstructionVariant) => [
  getTableTypicalColumn({
    dataKey: "typeName",
    isReadOnly: true,
    label: t(i18nKey(variant, "poolColumns.name")),
    valueClassName: catalogValueClassName,
  }),
  getTableTypicalColumn({
    dataKey: "uValue",
    isReadOnly: true,
    label: t(i18nKey(variant, "poolColumns.uValue")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayeredConstructionCatalogTableRow) => getNumberCatalogCell(t, row.uValue),
  }),
  getTableTypicalColumn({
    dataKey: "thicknessTotal",
    isReadOnly: true,
    label: t(i18nKey(variant, "poolColumns.thicknessTotal")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayeredConstructionCatalogTableRow) => getNumberCatalogCell(t, row.thicknessTotal),
  }),
  getTableTypicalColumn({
    dataKey: "layerCount",
    isReadOnly: true,
    label: t(i18nKey(variant, "poolColumns.layers")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayeredConstructionCatalogTableRow) => row.layers.length,
  }),
];

export const getLayerPoolTableHeaders = (t: TFunction, variant: LayeredConstructionVariant) => [
  getTableTypicalColumn({
    dataKey: "material",
    isReadOnly: true,
    label: t(i18nKey(variant, "layerColumns.material")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayerRow) => getStringCatalogCell(t, row.material),
  }),
  getTableTypicalColumn({
    dataKey: "thickness",
    isReadOnly: true,
    label: t(i18nKey(variant, "layerColumns.thickness")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayerRow) => getNumberCatalogCell(t, row.thickness),
  }),
  getTableTypicalColumn({
    dataKey: "density",
    isReadOnly: true,
    label: t(i18nKey(variant, "layerColumns.density")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayerRow) => getNumberCatalogCell(t, row.density),
  }),
  getTableTypicalColumn({
    dataKey: "thermalConductivity",
    isReadOnly: true,
    label: t(i18nKey(variant, "layerColumns.thermalConductivity")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayerRow) => getNumberCatalogCell(t, row.thermalConductivity),
  }),
  getTableTypicalColumn({
    dataKey: "heatCapacity",
    isReadOnly: true,
    label: t(i18nKey(variant, "layerColumns.heatCapacity")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: LayerRow) => getNumberCatalogCell(t, row.heatCapacity),
  }),
];
